import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../../config/ApiUrl";
import ADMIN_API_URL from "../../../config/AdminApiUrl";

export const getTenantsInquiries = createAsyncThunk(
  "TenantsInquiries/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== "",
        ),
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(
        `${ADMIN_API_URL.TENANT_INQUIRY.SLUG}?${queryString}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createTenantInquiry = createAsyncThunk(
  "TenantInquiry/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${ADMIN_API_URL.TENANT_INQUIRY.SLUG}`,
        payload,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const createTenantInquiryExternal = createAsyncThunk(
  "TenantInquiryExternal/create",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.post(
        `${ADMIN_API_URL.TENANT_INQUIRY.EXTERNAL_ADD}`,
        payload,
      );
      // const { active_payload } = getState().tenantInquiry;
      // dispatch(getTenantsInquiries(active_payload));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const deleteTenantInquiry = createAsyncThunk(
  "TenantInquiry/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(
        `${ADMIN_API_URL.TENANT_INQUIRY.SLUG}/${id}`,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const editTenantInquiry = createAsyncThunk(
  "TenantInquiry/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${ADMIN_API_URL.TENANT_INQUIRY.SLUG}`,
        payload,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const getTenantInquiryDetails = createAsyncThunk(
  "TenantInquiryDetails/get",
  async (Id, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${ADMIN_API_URL.TENANT_INQUIRY.SLUG}/${Id}`,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const approveTenantInquiry = createAsyncThunk(
  "approveTenantInquiry/post",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(
        `${ADMIN_API_URL.TENANT_INQUIRY.APPROVE}`,
        payload,
      );
      dispatch(getTenantInquiryDetails(payload?.id));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const rejectTenantInquiry = createAsyncThunk(
  "rejectTenantInquiry/put",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(
        `${ADMIN_API_URL.TENANT_INQUIRY.REJECT}`,
        payload,
      );
      dispatch(getTenantInquiryDetails(payload?.id));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const closeTenantInquiry = createAsyncThunk(
  "closeTenantInquiry/post",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(
        `${ADMIN_API_URL.TENANT_INQUIRY.CLOSE}`,
        payload,
      );
      dispatch(getTenantInquiryDetails(payload?.id));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

const tenantInquirySlice = createSlice({
  name: "tenantInquiry",
  initialState: {
    tenant_inquiry_list: [],
    state_list: [],
    current_values: null,
    active_payload: null,
    total_records: 0,
    tenant_inquiry_details: {},
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTenantsInquiries.fulfilled, (state, action) => {
        state.tenant_inquiry_list = action.payload.data.list;
        state.total_records = action.payload.data.totalRecords || 0;
      })
      .addCase(getTenantInquiryDetails.fulfilled, (state, action) => {
        state.tenant_inquiry_details = action.payload;
      });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  tenantInquirySlice.actions;
export default tenantInquirySlice.reducer;
